import { FC, ReactNode } from 'react';
import { ChevronArrowRightIcon } from 'assets/icons';

interface GlobalBannerProps {
  icon?: ReactNode;
  message: string;
  subMessage?: string;
  actionText?: string;
  onActionClick?: () => void;
  className?: string;
}

const GlobalBanner: FC<GlobalBannerProps> = ({
  icon,
  message,
  subMessage,
  actionText,
  onActionClick,
  className = ''
}) => {
  return (
    <div className={`flex items-center justify-between bg-toastBackground px-6 py-2 ${className}`}>
      <span className="flex items-center gap-2 text-sbase text-primaryText">
        {icon ? icon : null}
        <div className="flex flex-col">
          <span className="text-sbase font-bold text-primaryText">{message}</span>
          <span className="text-sbase font-normal text-primaryText">{subMessage}</span>
        </div>
      </span>
      {actionText && onActionClick && (
        <div
          className="flex cursor-pointer items-center text-sbase 
          font-semibold text-secondaryBtnText transition-colors hover:text-primaryText"
          onClick={onActionClick}
          tabIndex={0}
          role="button"
          aria-label={actionText}
          onKeyDown={e => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              onActionClick();
            }
          }}>
          {actionText}
          <span className="ml-1">
            <ChevronArrowRightIcon className="path-fill-current text-[#B1B1B1]" />
          </span>
        </div>
      )}
    </div>
  );
};

export default GlobalBanner;
